import UsageStatistics from './UsageStatistics';

export default UsageStatistics;
